<template>
  <div class="schlafberatung">
    <h1>Schlafberatung in Koblenz & Umgebung</h1>
    <p>Nirgends erhält man so viele ungefragte Ratschläge und Meinungen, wie wenn es um den kindlichen Schlaf geht. Daher begleite ich euch feinfühlig bei allen Fragen zur kindlichen Schlafentwicklung. Ihr erhaltet von mir Informationen, die auf aktuellen wissenschaftlichen Erkenntnissen beruhen.</p>
    <p>Habt ihr eine schwierige oder belastende Schlafsituation mit eurem Baby oder Kleinkind? In meiner Schlafberatung analysieren wir eure Situation sorgfältig und suchen gemeinsam nach einer Lösung, die die Bedürfnisse <strong>aller</strong> Beteiligten – Kind und Eltern – berücksichtigt. Bei mir gibt es niemals pauschale Ratschläge, sondern immer eine individuelle Sicht auf eure Familie.</p>
    <p>Ich distanziere mich von jeglichen Arten von Schlaftraining und werde euch niemals raten, euer Kind einfach schreien zu lassen!</p>
    <h2>Mögliche Beratungsthemen</h2>
    <ul>
      <li>Lange oder anstrengende Einschlafbegleitung</li>
      <li>Häufiges Erwachen und nächtliche Wachphasen</li>
      <li>Nächtliches Dauernuckeln</li>
      <li>Einbindung anderer Bezugspersonen in die (Ein-)Schlafbegleitung</li>
      <li>Veränderungen der Schlafgewohnheiten</li>
      <li>Nächtliches Abstillen oder Reduzierung des Stillens</li>
      <li>Wie kann mein (gestilltes) Kind in der Betreuung einschlafen?</li>
    </ul>
    <p>Was ist altersgerecht? Wie funktioniert der Schlaf bei Babys und Kleinkindern? Zu allgemeinen Themen der kindlichen Schlafentwicklung biete ich auch einen <router-link to="/schlafworkshop/">Schlafworkshop</router-link> an.</p>
  </div>
</template>

<script>
export default {
  name: 'Schlafberatung'
}
</script>

<style scoped>
.schlafberatung {
}
</style>